export const version = '0.770.0'
export const chameleonWebVersion = '9.6.1'
export const chameleonCoreVersion = '7.8.0'
